import ModuleManager from "./ModuleManager";

export const getModule = (name: string) => {
    return (window as any).__modules[name];
}
export { ModuleManager };
